import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID, TransferState } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApiService } from '@app/services/api/api.service';
import { SSR_DATA } from '@app/app-initializer';
import { HostelSearchParams, SearchService } from '@app/search.service';
import { BehaviorSubject, Observable, map, take } from 'rxjs';
import { PageComponent } from '@app/page/page.component';
import { HeaderComponent } from '@app/header/header.component';

@Component({
  selector: 'app-sitemap',
  standalone: true,
  imports: [CommonModule, RouterModule, PageComponent, HeaderComponent],
  templateUrl: './sitemap.component.html',
  styleUrl: './sitemap.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SitemapComponent {
  // public cities$: Observable<CityRef[]>;
  public cities$ = new BehaviorSubject<any[]>([]);
  public searchParams: Observable<HostelSearchParams>;

  constructor(
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: string,
    private searchService: SearchService,
    private transferState: TransferState
  ) {}

  ngOnInit() {
    this.searchParams = this.searchService.searchParams$;

    if (isPlatformBrowser(this.platformId)) {
      const ssrData = this.transferState.get(SSR_DATA, {});
      if (ssrData?.['CITIES']) {
        this.cities$.next(ssrData['CITIES']);
      } else {
        this.apiService.getCities()
          .pipe(
            map((resp: any) => {
              return resp.data;
            }),
            take(1),
          )
          .subscribe(data => {
            this.cities$.next(data);
          })
      }
    }
  }
}
